import { NotificacaoEvento, NotificacaoTipo } from "./notificacao";
import { validate } from "validate.js";

export class FiltroNotificacao {
    public notificacaoEventoId: NotificacaoEvento | null;
    public notificacaoTipoId: NotificacaoTipo | null;
    public dataInicio: Date;
    public dataFim: Date;
    public tamanhoLote: number;

    validate() {
        let validacao: any = {

            dataInicio: {
                presence: { allowEmpty: false, message: "campoObrigatorio" },
                dataMenorQue: { campo: "dataFim" }
            },
            dataFim: {
                presence: { allowEmpty: false, message: "campoObrigatorio" }
            }
        };

        return validate(this, validacao);
    }
}
